import React, { FC } from 'react'
import TextType, { TextProps } from './TextType'

export type SearchProps = TextProps

const SearchType: FC<SearchProps> = ({ ...rest }) => <TextType type="search" {...rest} />

export default SearchType
